import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import LogoAfr from '../../images/logo-afr.svg'
import { customTheme } from '../../styling'
import FormLabel from '@mui/material/FormLabel'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiCard from '@mui/material/Card'
import { Button, TextField, CircularProgress } from '@material-ui/core'
import { styled } from '@mui/material/styles'
import axios from '../../axios'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import SnackBar from '../../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../../constants'

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
        maxWidth: '450px',
    },
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
        boxShadow:
            'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}))

const SignInContainer = styled(Stack)(({ theme }) => ({
    backgroundColor: 'black',
    height: '100vh',
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
    },
}))

const ResetPassword = () => {
    const history = useHistory()
    const [resettingPassword, setResettingPassword] = useState(false)
    const [password, setPassword] = useState('')
    const [repeatPassword, setRepeatPassword] = useState('')
    const [resetPasswordError, setResetPasswordError] = useState('')
    const [loading, setLoading] = useState(false)
    const urlParams = new URLSearchParams(window.location.search)
    const resetPasswordToken = urlParams.get('token')
    const { enqueueSnackbar } = SnackBar.Consumer()

    useEffect(() => {
        setLoading(true)
        axios.post('/get-reset-password-user-token', {
            resetPasswordToken,
          }).then((res) => {
            
            setLoading(false)
            if(!res?.data){
                history.push('/login')
            }
            else if(!res.data.resetPasswordToken && res?.data?.expired){
                enqueueSnackbar('Il link per reimpostare la tua password è scaduto', {
                    variant: 'error',
                })
                history.push('/login')
            }
          }).catch((error) => {
            history.push('/login')
            setLoading(false)
          })
    },[])

    const handleResetPasswordRequest = async ({ password, resetPasswordToken }) => {
        const userCreds = await axios.post('/reset-user-password-with-token', {
            password,
            resetPasswordToken
        })
        return userCreds

    }
    const handleResetPassword = () => {
        if (password !== repeatPassword) {
            setResetPasswordError('Password non coincidono!')
            return
        }
        setResettingPassword(true)
        handleResetPasswordRequest({ password, resetPasswordToken }).then((res) => {
            enqueueSnackbar('Password reimpostata corretamente', {
                variant: 'success',
            })
            setResettingPassword(false)
            history.push('/login')

        }).catch((error) => {
            console.log(error)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })
            setResettingPassword(false)
        })
    }

    return (
        <Box>
            {/* <CssBaseline enableColorScheme /> */}
            
            <SignInContainer direction="column" justifyContent="space-between">
            {loading ? <Box style={{position:'absolute', top:'50%', left:'50%'}}><CircularProgress style={{color:'white'}} size={50} /></Box>
            :
            <>
                <img src={LogoAfr} style={{ height: '9vh', position: 'absolute', left: '35%', top: '15%' }} />
                {/* <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} /> */}
                <Card variant="outlined">
                    <Typography
                        component="h1"
                        variant="h4"
                        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)', color: `${'black'}` }}
                    >
                        Reset password
                    </Typography>
                    <Box

                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: 2,
                        }}
                    >




                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <FormLabel htmlFor="password">Nuova password</FormLabel>
                        </Box>
                        <TextField
                            name="password"
                            placeholder="••••••"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            autoFocus
                            required
                            fullWidth
                            variant="outlined"
                            onChange={(event) => setPassword(event.target.value)}

                        />

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <FormLabel htmlFor="password">Ripeti password</FormLabel>
                        </Box>
                        <TextField
                            error={resetPasswordError}
                            helperText={resetPasswordError}
                            name="password"
                            placeholder="••••••"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            autoFocus
                            required
                            fullWidth
                            variant="outlined"
                            onChange={(event) => setRepeatPassword(event.target.value)}
                            color={resetPasswordError ? 'error' : 'primary'}

                        />


                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color='primary'
                            onClick={() => handleResetPassword()}
                        >
                            {resettingPassword ? <CircularProgress size={25} color='white' /> : 'Continua'}
                        </Button>
                    </Box>


                </Card>
                </>
            }
            </SignInContainer>
        
        </Box>
    )
}

export default ResetPassword